import { Component, OnInit } from '@angular/core';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';

@Component({
  selector: 'tablero-presupuesto',
  templateUrl: './tablero-presupuesto.component.html',
  styleUrls: ['./tablero-presupuesto.component.scss']
})
export class TableroPresupuestoComponent implements OnInit {

  constructor(private facadeSesionService: FacadeSesionService) { }

  ngOnInit() {
    this.facadeSesionService.interfazService.mostrarBreadcrumb(true);
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad('Tablero Dirección General de Carreteras');
  }

}
